import React from "react";
import Link from "gatsby-link";
import moment from "moment";
import Thumbnail from "./Thumbnail";

class PostListing extends React.Component {
  getPostList() {
    const postList = [];
    const {postEdges} = this.props;
    postEdges.forEach(postEdge => {
      postList.push({
        path: postEdge.node.fields.slug,
        tags: postEdge.node.frontmatter.tags,
        cover: postEdge.node.frontmatter.cover,
        title: postEdge.node.fields.title,
        date: postEdge.node.fields.date,
        excerpt: postEdge.node.excerpt,
        timeToRead: postEdge.node.timeToRead,
        localThumbnail: postEdge.node.localThumbnail,
      });
    });
    return postList;
  }

  render() {
    const postList = this.getPostList();
    const {dateFormat} = this.props;

    return (
      <div className="columns is-multiline">
        {
          postList.map(post => (
            <div className="column is-one-quarter" key={`${moment(post.date).format(dateFormat)}-${post.title}`}>
              <div className="card" style={{height: "100%"}}>
                <div className="card-image">
                  <Thumbnail post={post} />
                </div>
                <div className="card-content">
                  <Link to={`/${post.path}`}>
                    <p className="is-size-6">
                      {post.title}
                    </p>
                  </Link>
                  <div className="tags" style={{paddingTop: "8px"}}>
                    <span className="tag is-link">
                      {moment(post.date).format(dateFormat)}
                    </span>
                    {
                      post.tags ?
                        post.tags.map(tag => (
                          <span className="tag" key={tag}>
                            {tag}
                          </span>
                        )) : null
                    }
                  </div>
                </div>
              </div>
            </div>
          ))}
      </div>
    );
  }
}

export default PostListing;



// WEBPACK FOOTER //
// ./src/components/PostListing/PostListing.jsx